import {Image} from 'antd'
import moment from 'moment'
import {useMemo, useState} from 'react'
import DialogCustom from 'src/components/elements/DialogCustom/DialogCustom'
import {BODY_PARTS_OPTIONS} from 'src/constants/constants'
import {ImageCardContainer, ImageContainer, InfoFooter, ScrollContainer} from './CompareImagesDialogStyles'

type CompareImagesDialogProps = {
  images: Record<string, any>[],
  onClose: () => void;
};

const CompareImagesDialog: React.FC<CompareImagesDialogProps> = ({images, onClose}) => {
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set())

  const imageUrls = useMemo(() => {
    return images.map(image => ({
      id: image._id,
      url: `psp-backend/images/download/${image.file}`,
      alt: `${image.bodyPart}_${image.plannedDate}`,
      bodyPart: BODY_PARTS_OPTIONS.find(option => option.value === image.bodyPart)?.label || image.bodyPart,
      date: moment(image.plannedDate).format('DD MMM YYYY'),
      bodyPartValue: image.bodyPart
    }))
  }, [images])

  useMemo(() => {
    imageUrls.forEach(({url, id}) => {
      const img = new window.Image()
      img.src = url
      img.onload = () => {
        setLoadedImages(prev => new Set(prev).add(id))
      }
    })
  }, [imageUrls])

  const imageCard = useMemo(() => {
    return imageUrls.map(({id, url, alt, bodyPart, date, bodyPartValue}) => (
      <ImageCardContainer key={id}>
        <ImageContainer>
          <Image
            alt={alt}
            loading='eager'
            placeholder={
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#999'
              }}
              >
                {'Caricamento...'}
              </div>
            }
            preview={{
              zIndex: 9999
            }}
            src={url}
            style={{
              maxWidth: 'calc(100% - 24px)',
              maxHeight: '346px',
              objectFit: 'contain',
              borderRadius: '4px',
              width: 'auto',
              height: 'auto',
              opacity: loadedImages.has(id) ? 1 : 0.5,
              transition: 'opacity 0.3s ease-in-out'
            }}
          />
        </ImageContainer>

        <InfoFooter>
          <div>
            {bodyPart}
          </div>
          <div>
            {date}
          </div>
        </InfoFooter>
      </ImageCardContainer>
    ))
  }, [imageUrls, loadedImages])

  const body = (
    <ScrollContainer>
      {imageCard}
    </ScrollContainer>
  )

  return (
    <DialogCustom
      body={body}
      maxWidth='lg'
      onClose={onClose}
      title={{text: 'Confronta immagini', format: false}}
    />
  )
}

export default CompareImagesDialog
